export default "__VITE_ASSET__4d9b8e0c__"